import { Injectable } from '@angular/core';
import { JwtHelperService } from '@auth0/angular-jwt';
import { AuthService } from './auth.service';
import { MatSnackBar } from '@angular/material/snack-bar';

@Injectable({
  providedIn: 'root',
})
export class JwtService {
  access;

  constructor(
    private authService: AuthService,
    private snackbar: MatSnackBar
  ) {}

  check() {
    this.access = sessionStorage.getItem('access');
    const helper = new JwtHelperService();
    if (this.access) {
      // To decode token
      //  const decodedToken = helper.decodeToken(this.access);
      //  const expirationDate = helper.getTokenExpirationDate(this.access);
      const isExpired = helper.isTokenExpired(this.access);
      sessionStorage.setItem('isUserLoggedIn', isExpired ? 'false' : 'true');
      if (isExpired) {
        this.snackbar.open('Session expired Please login', undefined, {
          duration: 5000,
          panelClass: 'mandatory',
        });
        this.authService.logout();
      }
    } else {
      this.snackbar.open('Please login to use the page', undefined, {
        duration: 5000,
        panelClass: 'mandatory',
      });
      this.authService.logout();
    }
  }
}
